import React, { useState, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import moment from 'moment';
import { any, objectOf } from 'prop-types';
import {
  Tabela,
  Filtros,
  Header,
  BotaoPrimario,
  BotaoDefault,
} from '../../components/layout';
import { DiaNaoTrabalhadoForm } from '../../components/forms';
import { useApi, useUrl } from '../../hooks';
import { ModalBusca } from '../../components/modais';
import { Container } from '../styles';
import { DIAS_NAO_TRABALHADOS } from '../../components/layout/Tabela/nomesCabecalhos';
import { DIA_NAO_TRABALHADO_LAYOUT } from '../../components/layout/Filtros/nomeFiltros';
import { EXCLUIR } from '../../components/layout/Tabela/nomesAcoes';
import { telaGrande } from '../../utils';
import {
  CADASTRAR,
  FILTRAR,
  ATIVAR_FILTRO,
  BUSCAR,
  DIA_NAO_TRABALHADO,
} from '../../hooks/useUrl/acoes';

const { Tags, TituloComFiltro } = Filtros;

const DiasNaoTrabalhados = ({ history }) => {
  const { deletar, buscar } = useApi();
  const { existeQuery, adicionarQuery, removerQuery, pegarValorQuery } = useUrl(
    history,
  );
  const [filtro, setFiltro] = useState('');
  const [dias, setDias] = useState([]);
  const busca = pegarValorQuery(BUSCAR);
  const [diaSelecionado, setDiaSelecionado] = useState(null);
  const mostrarCadastro = existeQuery(CADASTRAR, DIA_NAO_TRABALHADO);
  const { loading } = useSelector(({ reducer }) => reducer, shallowEqual);
  const [pagina, setPagina] = useState(1);

  const deletarDia = async ({ uid, data }) => {
    await deletar(
      `/dias-nao-trabalhados/${uid}`,
      `O dia não trabalhado ${moment(data).format('DD/MM/YYYY')} foi excluído!`,
      () => setDias(dias.filter(({ uid: diaUid }) => diaUid !== uid)),
    );
  };

  useEffect(() => {
    const carregarDias = async () => {
      if (pagina === 1) {
        setDias([]);
      }

      if (filtro === '') {
        const { data } = await buscar(
          `/dias-nao-trabalhados?${filtro}${
            busca ? `&$buscar=${busca}` : ''
          }&$ordem=data&$limite=10&$pagina=${pagina}`,
        );
        setDias(dia => [...dia, ...data]);
      }

      if (filtro !== '') {
        const { data } = await buscar(
          `/dias-nao-trabalhados?${filtro}${
            busca ? `&$buscar=${busca}` : ''
          }&$ordem=data&`,
        );
        setDias(data);
        setPagina(1);
      }
    };
    carregarDias();
  }, [buscar, filtro, busca, pagina]);

  useEffect(() => {
    if (filtro === '') {
      const intersectionObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          setPagina(page => page + 1);
        }
      });

      intersectionObserver.observe(document.querySelector('#final'));
      return () => intersectionObserver.disconnect();
    }

    return undefined;
  }, [filtro]);

  const retornarQuery = query => filtro !== query && setFiltro(query);

  return (
    <Container>
      <Header
        transparente
        semPadding="true"
        title={
          <TituloComFiltro
            titulo="Dias Não Trabalhados"
            history={history}
            busca={busca}
          />
        }
        extra={[
          <BotaoDefault
            disabled={loading}
            key="1"
            htmlType="button"
            onClick={() => adicionarQuery(FILTRAR, ATIVAR_FILTRO)}
          >
            Filtrar
          </BotaoDefault>,
          <BotaoPrimario
            disabled={loading}
            key="2"
            type="primary"
            htmlType="button"
            onClick={() => adicionarQuery(CADASTRAR, DIA_NAO_TRABALHADO)}
          >
            Novo Dia
          </BotaoPrimario>,
        ]}
      />
      <Tags retornarQuery={retornarQuery} history={history} />
      <Tabela
        cabecalho={DIAS_NAO_TRABALHADOS}
        dados={dias}
        loading={loading}
        celulaSelecionada={dia => {
          setDiaSelecionado(dia);
          adicionarQuery(CADASTRAR, DIA_NAO_TRABALHADO);
        }}
        acoes={
          telaGrande()
            ? [{ titulo: EXCLUIR, onClick: deletarDia, confirmacao: true }]
            : null
        }
      />

      <DiaNaoTrabalhadoForm
        dia={diaSelecionado}
        mostrar={mostrarCadastro}
        aoFechar={() => {
          removerQuery(CADASTRAR, DIA_NAO_TRABALHADO);
          setDiaSelecionado(null);
        }}
        afterSubmit={dia => {
          if (dia) {
            setDias([...dias.filter(({ uid }) => uid !== dia.uid), dia]);
            removerQuery(CADASTRAR, DIA_NAO_TRABALHADO);
          }
        }}
      />

      <ModalBusca
        retornarQuery={retornarQuery}
        history={history}
        nomeFiltro={DIA_NAO_TRABALHADO_LAYOUT}
      />
      {filtro === '' ? <div id="final" /> : null}
    </Container>
  );
};

DiasNaoTrabalhados.propTypes = {
  history: objectOf(any).isRequired,
};

export default DiasNaoTrabalhados;
